



















import _ from 'lodash'
import qs from 'qs'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { Filter, FilterTypes } from '@/interfaces/filter'
import { QueryMixin } from '@/mixins/query.mixin'
import { GetFilterValuesMixin } from '@/mixins/filter-values.mixin'
import InputFilter from '@/components/filters/Input.vue'
import CheckboxFilter from '@/components/filters/Checkbox.vue'
import CheckboxGroupFilter from '@/components/filters/CheckboxGroup.vue'
import RadioFilter from '@/components/filters/Radio.vue'
import DatePicker from '@/components/filters/DatePicker.vue'
import RangePickerFilter from '@/components/filters/RangePicker.vue'
import TimePickerFilter from '@/components/filters/TimePicker.vue'
import SelectFilter from '@/components/filters/Select.vue'

@Component
export default class Filters extends mixins(QueryMixin, GetFilterValuesMixin) {
  @Prop(String)
  readonly entity!: string

  @Prop(Array)
  readonly filters!: Filter[]

  components = {
    [FilterTypes.INPUT]: InputFilter,
    [FilterTypes.CHECKBOX]: CheckboxFilter,
    [FilterTypes.CHECKBOX_GROUP]: CheckboxGroupFilter,
    [FilterTypes.RADIO]: RadioFilter,
    [FilterTypes.DATE_PICKER]: DatePicker,
    [FilterTypes.RANGE_PICKER]: RangePickerFilter,
    [FilterTypes.TIME_PICKER]: TimePickerFilter,
    [FilterTypes.SELECT]: SelectFilter
  }

  filterTimeout: number | null = null

  @Watch('filterValues')
  onFiltersChange(filters) {
    if (this.filterTimeout) clearTimeout(this.filterTimeout)

    this.filterTimeout = setTimeout(() => {
      const parsed = _.cloneDeep(this.parsedQuery)
      const value = _.isEmpty(filters) ? undefined : JSON.stringify(filters)

      _.set(parsed, ['filter', this.entity], value)
      this.$router.replace(`${this.$route.path}?${qs.stringify(parsed)}`)
    }, 300)
  }

  @Watch('$route', { immediate: true })
  onRouteChange() {
    const filterValue = _.get(this.parsedQuery, ['filter', this.entity])
    let parsed = {}
    try {
      parsed = JSON.parse(filterValue)
    } catch (e) {}

    this.filters.forEach(filter => {
      const value = _.get(parsed, filter.name)
      if (filter.value !== value) {
        this.$set(filter, 'value', value)
      }
    })
  }
}
